<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
            <div class="title">
              {{ title }}
              <div class="clear"></div>
            </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/alertMixins';
  import util from '@/mixins/util';
  import localStorage from '@/mixins/localStorage'
  import userInfo from '@/mixins/userInfo';

    export default {
        name: 'Main',
        mixins: [ VuxAlert, localStorage , userInfo ],
        components: {
        },
        data() {
          return{
            title: this.$route.meta.title,
          }
        },
        beforeRouteLeave(to, from, next){
            if(to.path === "/auth" && this.$localStorage.get('token')){
                next(false);
            }else{
                return next();
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
